<template>
  <div class="clicksign">
    <embed v-if="minuta && minuta.length" :src="minuta" />
    <div v-if="id && id.length" id="clicksign"></div>
  </div>
</template>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.clicksign
  min-width: 800px
  overflow: hidden
  border-radius: 23px
  @media (max-width: $small)
    min-width: 100%

  #clicksign, embed
    width: 100%
    height: 600px
</style>

<script>
/* global Clicksign */
import { env } from '../../conf/conf.js'
import { mapGetters } from "vuex";
export default {
  name: "Clicksign",
  props: { minuta: String, id: String },
  data() {
    return {
    };
  },
  methods: {
    start() {
      if (this.id) {

        var widget;
        if (widget) widget.unmount();

        widget = new Clicksign(this.id);
        widget.endpoint = this.user.config.url_clicksign
        if (env == 'prod') {
          widget.origin = "https://nssupport.netsupport.com.br";
         /*  widget.endpoint = "https://app.clicksign.com"; */
        } else {
          widget.origin = "http://localhost:8080";
         /*  widget.endpoint = "https://sandbox.clicksign.com"; */
        }
        widget.mount("clicksign");

        widget.on("loaded", function () {
        });
        widget.on("signed", function () {
          if (this.modal.callback) this.modal.callback();
          if (this.modal.cb) this.modal.cb();
        });
        widget.on("resized", function (height) {
          document.getElementById("clicksign").style.height = height + "px";
        });
      }
    }
  },
  mounted() {
    if (this.id) this.start()
  }, computed: {
    ...mapGetters("user", ["user"])
  }
};
</script>
